<template>
  <li class="nav-item align-self-center cursor-pointer" v-if="$auth.can({account: 'read'}, 'permissions')">
    <el-tooltip :content="$t('userAccountsSearch.title')"
                effect="light"
                :open-delay="300"
                placement="bottom">
    <router-link
      :to="{name: 'search'}">
      <i class="mdi mdi_icon mdi-24px mdi-account-search-outline"/>
    </router-link>
    </el-tooltip>
  </li>

</template>
<script>

export default {
  name: 'account-search-nav',
  components: {},
};
</script>
